import template        from "./button-fermentation-edit.html";
import css             from "./button-fermentation-edit.css";

import {Button}   	   from "gui";


class EditFermentationButton extends Button {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-button-fermentation-edit", EditFermentationButton);
  }
  static get schema() {
    return({
      "description": "User defined button that is disabled when there is not running fermentation",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  constructor(...args) {
    super(...args);

    this.disabled = true;
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));
    this.addEventListener("click", this.onclick_handler.bind(this));    
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;

    this.disabled = true;

    for (const fermentation of fermentations) {  
      if (fermentation.running) {
        this.disabled = false;
        this.__id = fermentation.id;
      }
    }
  }
  async onclick_handler() {
    var module = await import("../inc/dialog-new.js");
    var NewDialog = module.default;
    new NewDialog(this.__id);
  }
}

EditFermentationButton.constructor();

export default EditFermentationButton;